
import MarketPlaceLogoSimple from './MarketPlaceSimple.vue'
export default {
  components: {
    MarketPlaceLogoSimple
  }
}
